import { IntegratedGiftCardProviders } from '@daymade/common-lib/constants';
import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import { zodSelectIntegratedGiftCard } from '../generated/zodSchemas.generated';

export const ZSupportedGiftCardProviders = z.enum(IntegratedGiftCardProviders);

export const ZGiftCardSelect = zodSelectIntegratedGiftCard.extend(
  ensureSubsetOfKeys(zodSelectIntegratedGiftCard.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    expiresAt: z.coerce.date().nullable(),
  }),
);
